import styles from "./dashboard-panel.module.scss";

const cssClassName = "dashboard-panel";

export const getGridClass = (gridArea) => {
  switch (gridArea) {
    case "quarter":
      return styles[`${cssClassName}--grid-quarter`];
    case "third":
      return styles[`${cssClassName}--grid-third`];
    case "half":
      return styles[`${cssClassName}--grid-half`];
    case "full":
      return styles[`${cssClassName}--grid-full`];
    default:
      return "";
  }
};
